// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1VJLT","colMin":"styles_colMin__173kc","colCheckbox":"styles_colCheckbox__1kxxg"};